import {
  SCORECARD_DEFAULT_AGGREGATION,
  type ConfigureScorecardRequest,
  type Scorecard,
  type ScorecardStep,
} from "@/queries/smart-tables/scorecard";

const isPersistedStepId = (stepId: string): boolean =>
  !stepId.startsWith("draft-") && !stepId.startsWith("pending-");

export const toConfigureStepPayload = (
  step: ScorecardStep,
  options?: { orderIndex?: number; includeId?: boolean },
): ConfigureScorecardRequest["steps"][number] => {
  const payload: ConfigureScorecardRequest["steps"][number] = {
    title: step.title,
    primitive_type: step.primitive_type,
    source_column_ids: step.source_column_ids,
    weight: step.weight,
    required: step.required,
    thresholds: step.thresholds,
    primitive_config: step.primitive_config,
    order_index: options?.orderIndex ?? step.order_index,
  };

  if (options?.includeId !== false && isPersistedStepId(step.id)) {
    payload.id = step.id;
  }

  return payload;
};

export const buildConfigureStepsPayload = (
  scorecard: Scorecard,
  updatedStep: ScorecardStep,
  removeStepId?: string,
): ConfigureScorecardRequest["steps"] =>
  scorecard.steps
    .filter(step => step.id !== removeStepId)
    .map(step => toConfigureStepPayload(step.id === updatedStep.id ? updatedStep : step));

export const buildConfigureScorecardPayload = (
  scorecard: Scorecard,
  steps: ConfigureScorecardRequest["steps"],
): ConfigureScorecardRequest => ({
  name: scorecard.name,
  evaluated_column_ids: scorecard.evaluated_column_ids,
  aggregation: scorecard.aggregation ?? SCORECARD_DEFAULT_AGGREGATION,
  display_config: scorecard.display_config,
  baseline_config: scorecard.baseline_config,
  steps,
});
